import { useState } from "react";
import { CustomButton } from "../../../../components/CustomButton";
import * as S from './styles';
import RModal from "../../../../components/Rsuite/Modal";
import { Spacer } from "../../../../components/Spacer";
import { useAlert } from "../../../../contexts/Alert.context";
import { useAuth } from "../../../../hooks/auth";
import api from "../../../../services/api";
import { toastSuccess, toastError } from "../../../../toasts";

const EraseDatabase = ({ show, onClose }) => {
  const { id_empresa } = useAuth();
  const { showAlert } = useAlert();
  const [password, setPassword] = useState('');

  const eraseDatabase = async () => {
    await api.post('erase-company', { company_id: id_empresa, password })
      .then(() => {
        toastSuccess('Base de dados apagada com sucesso.', 'Sucesso');
        onClose();
      })
      .catch((error) => {
        toastError(error.response?.data?.message || 'Não foi possível apagar a base de dados.');
      });
  }

  const confirmCopyCompany = () => {
    if (!password) {
      toastError('Informe a senha para continuar.');
      return;
    }

    showAlert({
      title: 'Zerar Empresa',
      text: 'Deseja realmente zerar empresa?',
      onSubmit: () =>
        eraseDatabase(),
    });
  };

  return (
    <RModal
      title=""
      open={show}
      onClose={onClose}
      footer={
        <>
          <CustomButton appearance="default" onClick={onClose}>
            Fechar
          </CustomButton>
          <CustomButton
            appearance="primary"
            color="red"
            onClick={confirmCopyCompany}
          >
            Zerar
          </CustomButton>
        </>
      }
    >
        <S.Header>
          <S.AlertIcon>⚠️</S.AlertIcon>
          <S.Title>ATENÇÃO! Ação Irreversível</S.Title>
        </S.Header>
        <S.Body>
          <p>Você está prestes a <strong>APAGAR PERMANENTEMENTE</strong> toda a base de dados deste cliente.</p>

          <S.WarningBox>
            <p>Isso resultará na perda total de:</p>
            <ul>
              <li>Histórico de pedidos e vendas</li>
              <li>Produtos e configurações</li>
              <li>Relatórios financeiros</li>
            </ul>
          </S.WarningBox>

          <S.DangerText>
            Esta ação NÃO pode ser desfeita. Não haverá como recuperar esses dados após a confirmação.
          </S.DangerText>

          <S.InputWrapper>
            <S.Label htmlFor="confirmInput">
              Para confirmar, digite a senha do dia abaixo:
            </S.Label>
            <S.Input
              id="confirmInput"
              type="password"
              placeholder={`Digite a senha do dia`}
              autoComplete="off"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </S.InputWrapper>
        </S.Body>
      <Spacer y={8} />
    </RModal>
  );
}

export default EraseDatabase;
